import { ReactNode } from "react";
import { createPortal } from "react-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import styles from "./styles.module.scss";

// ── Współdzielony shell prawego slajdu „Filtr" ──────────────────────────────
//
// Prezentacja modalu typu prawy slajd (overlay + panel z prawej krawędzi).
// Rejestry KSeF/Operacje finansowe/Bilans próbny mają własne, spójne wizualnie
// panele; ten shell służy listom, które takiego panelu nie miały (Wydatki),
// żeby „Filtr" był wszędzie prawym slajdem.

interface Props {
  open: boolean;
  title?: string;
  onClose: () => void;
  onReset?: () => void;
  showReset?: boolean;
  children: ReactNode;
}

const FilterSlidePanel = ({
  open,
  title = "Filtr",
  onClose,
  onReset,
  showReset = false,
  children,
}: Props) => {
  if (!open) return null;

  return createPortal(
    <div className={styles.overlay} onClick={onClose}>
      <div
        className={styles.panel}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={styles.panelHeader}>
          <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
            <span className={styles.panelTitle}>{title}</span>
          </div>
          <div className={styles.panelHeaderActions}>
            {showReset && onReset && (
              <button className={styles.resetBtn} onClick={onReset}>
                Wyczyść
              </button>
            )}
            <button className={styles.closeBtn} onClick={onClose}>
              <FontAwesomeIcon icon={faXmark} />
            </button>
          </div>
        </div>
        <div className={styles.panelBody}>{children}</div>
      </div>
    </div>,
    document.body,
  );
};

export default FilterSlidePanel;
